import { SubscriptionContext } from "@/app/_providers/SubscriptionProvider/SubscriptionProvider";
import { useContext } from "react";

export const useSubscriptionContext = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error(
      "useSubscriptionContext must be used within a SubscriptionProvider"
    );
  }

  return context.subscriptionContext;
};

export const useIsSubscriptionReady = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error(
      "useIsSubscriptionReady must be used within a SubscriptionProvider"
    );
  }
  return context.isSubscriptionReady;
};

export const useRefreshSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error(
      "useRefreshSubscription must be used within a SubscriptionProvider"
    );
  }
  return context.refreshSubscription;
};

export const useSetSubscriptionContext = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error(
      "useSetSubscriptionContext must be used within a SubscriptionProvider"
    );
  }
  return context.setSubscriptionContext;
};
